<template>
  <div class="calico-progressbar-step-page">
    <div class="calico-progressbar-step-container">
      <calico-progreebar-step />
      <calico-progreebar-step :active="true" />
      <calico-progreebar-step :complete="true" />
    </div>
  </div>
</template>

<script lang="js">
import CalicoProgreebarStep from '@/components/calico/progressBarStep/index.vue'
export default {
  name: 'CalicoProgressbarStepPage',
  components: {
    CalicoProgreebarStep
  }
}
</script>

<style lang="scss">
.calico-progressbar-step-page {
  display: flex;
  justify-content: center;
  align-items: center;
  .calico-progressbar-step-container {
    @include stack-space($space-medium);
    @include inset-space($space-medium);
    width: 178px;
  }
}
</style>
